import http from "../http/http-config";
import { GetSafeHealthMaxRequotationResponse } from "../models/getSafeHealthMaxRequotationResponse";

export default new class getSafeHealthMaxRequotation {
    async getSafeHealthMaxRequotation(numberOfPeople, quotationId): Promise<GetSafeHealthMaxRequotationResponse> {
        const response = await http.get<GetSafeHealthMaxRequotationResponse>("GetSafeHealthMaxRequotation", {
            params: {
                numberOfPeople,
                quotationId
            }
        });
        if (response.status === 204) {
            throw new Error(response.status.toString());
        }
        return response.data;
    }
}
